import { FormatChartDataReturn, GroupBy } from "../../types/functions";
import { formatSeriesDefault, formatSeriesLine } from "./formatChartSeries";
import { groupByInterval, groupByString } from "./groupBy";
import { FormatSeriesLineReturn, Interval } from "./types";

interface FormatPropsLine {
  data: MyDatum[];
  indexBy: string;
  keys: (string | Object)[];
  groupBy?: GroupBy;
  interval?: Interval;
  groupMethod?: "sum" | "average";
}
interface FormatPropsDefault {
  data: MyDatum[];
  indexBy: string;
  keys: (string | Object)[];
  groupBy?: GroupBy;
  formatSeries: "default";
  interval?: Interval;
  groupMethod?: "sum" | "average";
}

const formatData = ({
  data,
  indexBy,
  keys,
  groupBy,
  formatSeries = "default",
  interval = "month",
  groupMethod = "sum",
}: FormatPropsDefault): FormatChartDataReturn => {
  if (formatSeries === "default") {
    let { formattedData, keyNames } = formatSeriesDefault(data, indexBy, keys);
    if (groupBy === "category") {
      formattedData = groupByString({
        data: [...formattedData],
        keys: keyNames,
        indexBy,
      });
    } else if (groupBy === "date") {
      formattedData = groupByInterval({
        data: [...formattedData],
        keys: keyNames,
        indexBy,
        interval,
        method: groupMethod,
      });
    }

    return { formattedData, keyNames };
  }

  return { formattedData: data, keyNames: [] };
};

const formatDataLine = ({
  data,
  indexBy,
  keys,
  groupBy,
  groupMethod = "sum",
  interval = "month",
}: FormatPropsLine): FormatSeriesLineReturn => {
  let { formattedData, keyNames } = formatSeriesDefault(data, indexBy, keys);

  if (groupBy === "category") {
    formattedData = groupByString({
      data: [...formattedData],
      keys: keyNames,
      indexBy: indexBy,
    });
  } else if (groupBy === "date") {
    formattedData = groupByInterval({
      data: [...formattedData],
      keys: keyNames,
      indexBy: indexBy,
      interval,
      method: groupMethod,
    });
  }
  let formattedDataLine = formatSeriesLine(formattedData, indexBy, keyNames);
  return {
    formattedData: formattedDataLine.formattedData,
    keyNames: formattedDataLine.keyNames,
  };
};

export { formatData, formatDataLine };
